/** @format */

import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { colors } from "../../utility/types/constant";

export const HowItWorksContainer = styled(Box)(({ theme }) => ({
	padding: "100px 20px",
	backgroundColor: "#ffffff",
	position: "relative",
	overflow: "hidden",
	[theme.breakpoints.down("md")]: {
		padding: "60px 20px",
	},
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(2rem, 4vw, 3rem)",
	fontWeight: 800,
	color: colors.primary,
	marginBottom: "16px",
	letterSpacing: "-0.02em",
}));

export const SectionSubtitle = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(1rem, 2vw, 1.25rem)",
	fontWeight: 400,
	color: "#6c757d",
	maxWidth: "700px",
	margin: "0 auto",
	lineHeight: 1.7,
}));

export const StepsContainer = styled(Box)(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "1fr auto 1fr auto 1fr auto 1fr",
	gap: "20px",
	alignItems: "center",
	[theme.breakpoints.down("lg")]: {
		gridTemplateColumns: "1fr auto 1fr",
		"& > *:nth-of-type(n+5)": {
			gridColumn: "1 / -1",
		},
	},
	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "1fr",
		gap: "40px",
	},
}));

export const StepCard = styled(Box)(({ theme }) => ({
	backgroundColor: "#ffffff",
	borderRadius: "20px",
	padding: "40px 30px",
	boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
	border: "2px solid rgba(0,0,0,0.05)",
	transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
	textAlign: "center",
	position: "relative",
	overflow: "hidden",
	"&::before": {
		content: '""',
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		height: "4px",
		background: colors.mainSecondary,
		transform: "scaleX(0)",
		transition: "transform 0.4s ease",
	},
	"&:hover": {
		transform: "translateY(-10px)",
		boxShadow: "0 20px 40px rgba(30, 193, 149, 0.2)",
		borderColor: colors.mainSecondary,
		"&::before": {
			transform: "scaleX(1)",
		},
	},
	[theme.breakpoints.down("md")]: {
		padding: "30px 20px",
	},
}));

export const StepNumber = styled(Typography)(({ theme }) => ({
	position: "absolute",
	top: "10px",
	right: "15px",
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(48px, 6vw, 72px)",
	fontWeight: 900,
	color: "rgba(30, 193, 149, 0.08)",
	lineHeight: 1,
}));

export const StepIconWrapper = styled(Box)(({ theme }) => ({
	width: "80px",
	height: "80px",
	borderRadius: "50%",
	backgroundColor: colors.mainSecondary,
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	margin: "0 auto 24px auto",
	color: "#ffffff",
	transition: "all 0.3s ease",
	boxShadow: "0 8px 20px rgba(30, 193, 149, 0.3)",
}));

export const StepTitle = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "clamp(1.25rem, 2vw, 1.5rem)",
	fontWeight: 700,
	color: colors.primary,
	marginBottom: "12px",
}));

export const StepDescription = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "0.9375rem",
	fontWeight: 400,
	color: "#6c757d",
	lineHeight: 1.7,
}));

export const ConnectorLine = styled(Box)(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	[theme.breakpoints.down("md")]: {
		display: "none",
	},
}));

export const AnimatedArrow = styled(Box)(({ theme }) => ({
	color: colors.mainSecondary,
	animation: "slideRight 2s ease-in-out infinite",
	"@keyframes slideRight": {
		"0%, 100%": {
			transform: "translateX(0)",
		},
		"50%": {
			transform: "translateX(10px)",
		},
	},
}));
